import PropTypes from '@viking-eng/prop-types';
import React from 'react';

const FieldValidationError = ({ errorCode, errorCodes = {}, errorMessages = {}, tabIndex = 0 }) => (
  <span
    role="alert"
    className="w-100 d-block text-viking-red xsmall-body-copy validation-error-text"
    tabIndex={tabIndex}
  >
    {errorMessages?.[errorCodes?.[errorCode]] || errorCode}
  </span>
);

FieldValidationError.propTypes = {
  errorCode: PropTypes.string.isRequired,
  errorCodes: PropTypes.errorCodes,
  errorMessages: PropTypes.errorMessages,
  tabIndex: PropTypes.number,
};

export default FieldValidationError;
